import { render, staticRenderFns } from "./Lyric.vue?vue&type=template&id=3f32b638&"
import script from "./Lyric.vue?vue&type=script&lang=js&"
export * from "./Lyric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports